export const BEHAVIOR_ACTION_TYPE__HIDE_QUESTION = 'hideQuestion';
export const BEHAVIOR_ACTION_TYPE__SHOW_QUESTION = 'showQuestion';
export const BEHAVIOR_ACTION_TYPE__HIDE_QUESTION_CHUNK = 'hideQuestionChunk';
export const BEHAVIOR_ACTION_TYPE__SHOW_QUESTION_CHUNK = 'showQuestionChunk';
export const BEHAVIOR_ACTION_TYPE__SKIP_TO_QUESTION = 'skipToQuestion';
export const BEHAVIOR_ACTION_TYPE__UNKNOWN = 'unknown';

export const BEHAVIOR_ACTION_TYPES = [
  BEHAVIOR_ACTION_TYPE__HIDE_QUESTION,
  BEHAVIOR_ACTION_TYPE__SHOW_QUESTION,
  BEHAVIOR_ACTION_TYPE__HIDE_QUESTION_CHUNK,
  BEHAVIOR_ACTION_TYPE__SHOW_QUESTION_CHUNK,
  BEHAVIOR_ACTION_TYPE__SKIP_TO_QUESTION,
  BEHAVIOR_ACTION_TYPE__UNKNOWN,
];

export const BEHAVIOR_CONDITION_TYPE__ALWAYS = 'always';
export const BEHAVIOR_CONDITION_TYPE__NEVER = 'never';
export const BEHAVIOR_CONDITION_TYPE__CUSTOM = 'custom';
export const BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_IS_ONE_OF =
  'thisAnswerIsOneOf';
export const BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_IS_ONE_OF =
  'anotherAnswerIsOneOf';
export const BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_IS_NOT_ONE_OF =
  'thisAnswerIsNotOneOf';
export const BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_IS_NOT_ONE_OF =
  'anotherAnswerIsNotOneOf';
export const BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_EXISTS = 'thisAnswerExists';
export const BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_EXISTS =
  'anotherAnswerExists';
export const BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_DOES_NOT_EXIST =
  'thisAnswerDoesNotExist';
export const BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_DOES_NOT_EXIST =
  'anotherAnswerDoesNotExist';
export const BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_IS_MISSING_OR_IS_ONE_OF =
  'thisAnswerMissingOrOneOf';
export const BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_IS_MISSING_OR_IS_ONE_OF =
  'anotherAnswerMissingOrOneOf';
export const BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_IS_MISSING_OR_IS_NOT_ONE_OF =
  'thisAnswerMissingOrNotOneOf';
export const BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_IS_MISSING_OR_IS_NOT_ONE_OF =
  'anotherAnswerMissingOrNotOneOf';

export const BEHAVIOR_CONDITION_TYPES = [
  BEHAVIOR_CONDITION_TYPE__ALWAYS,
  BEHAVIOR_CONDITION_TYPE__NEVER,
  BEHAVIOR_CONDITION_TYPE__CUSTOM,
  BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_IS_ONE_OF,
  BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_IS_ONE_OF,
  BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_IS_NOT_ONE_OF,
  BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_IS_NOT_ONE_OF,
  BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_EXISTS,
  BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_EXISTS,
  BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_DOES_NOT_EXIST,
  BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_DOES_NOT_EXIST,
  BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_IS_MISSING_OR_IS_ONE_OF,
  BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_IS_MISSING_OR_IS_ONE_OF,
  BEHAVIOR_CONDITION_TYPE__THIS_ANSWER_IS_MISSING_OR_IS_NOT_ONE_OF,
  BEHAVIOR_CONDITION_TYPE__ANOTHER_ANSWER_IS_MISSING_OR_IS_NOT_ONE_OF,
];
